import React, {Component} from "react";
import {Link} from "react-router-dom";
// La instancia global (la inicializa `src/i18n.js` al arrancar la app): esta celda es una clase sin el HOC.
import i18n from "i18next";
import {isRecalculating} from "../../alerts_center/shared/recalculation";
import {UrlListButton} from "../UrlListButton";
import {AssignBusinessUnitLabelsButton} from "../AssignBusinessUnitLabelsButton";
import {BusinessUnitSyncAlertIcon} from "../BusinessUnitSyncAlertTooltip";
import {SnoozeAllAlertsButton} from "../SnoozeAllAlertsButton";
import {BusinessUnitAdAccountGeneralAlertIcon} from "../BuccGeneralAlertTooltip";
import {BusinessUnitShowAdAccountsOrCampaignsTooltip} from "../BusinessUnitShowAdAccountsOrCampaignsTooltip";
import {CHANNEL_INFO_BY_CHANNEL, CHANNEL_TYPE_PAID_MEDIA, CHANNEL_TYPE_ECOMMERCE, CHANNEL_TYPE_ANALYTICS} from "../../channels/channels";
import {anchorAttr} from "../../../guides/anchors";
import {UncoveredSpendChip} from "../../elements/UncoveredSpendChip";
import {hasUncoveredSpend, ruleLeakOf} from "../../elements/uncoveredSpend";

export class BusinessUnitNameCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            counter: 0
        };

        this.doRender = this.doRender.bind(this);
    }

    doRender() {
        this.setState({'counter': this.state.counter+1});
    }

    getChannelClassName() {
        if (this.props.channels.length === 1) {
            return ("bu-cell -" + this.props.channels[0].toLowerCase())
        } else {
            // Separar canales publicitarios/ecommerce de Analytics
            const nonAnalyticsChannels = this.props.channels.filter(channel => {
                const channelInfo = CHANNEL_INFO_BY_CHANNEL[channel];
                return channelInfo && 
                       (channelInfo.channelType === CHANNEL_TYPE_PAID_MEDIA || 
                        channelInfo.channelType === CHANNEL_TYPE_ECOMMERCE);
            });
            
            const analyticsChannels = this.props.channels.filter(channel => {
                const channelInfo = CHANNEL_INFO_BY_CHANNEL[channel];
                return channelInfo && channelInfo.channelType === CHANNEL_TYPE_ANALYTICS;
            });
            
            // Si hay solo un canal publicitario/ecommerce + Analytics, usar clase con dos barras
            if (nonAnalyticsChannels.length === 1 && analyticsChannels.length === 1 && this.props.channels.length === 2) {
                const nonAnalyticsChannel = nonAnalyticsChannels[0].toLowerCase();
                return ("bu-cell -" + nonAnalyticsChannel + "-analytics")
            } else {
                // Si hay múltiples canales publicitarios/ecommerce + Analytics, mostrar violeta con Analytics
                if (nonAnalyticsChannels.length > 1 && analyticsChannels.length === 1) {
                    return ("bu-cell -mixed-analytics")
                } else {
                    // El violeta solo para cuando hay múltiples canales publicitarios/ecommerce sin Analytics
                    return ("bu-cell -mixed")
                }
            }
        }
    }

    // El recorrido del Tablero apunta al cliente, a la línea y al «+» de la primera fila (`guideRow`,
    // lo decide `Dashboard`). En las demás filas no se marca nada.
    onGuideRow(anchor) {
        return this.props.guideRow ? anchor : {};
    }

    render() {
        const isClientView = this.props.viewMode === 'client';

        const nameBlock = (
            <div className="bu-name-with-tooltip">
                <div className="bu-name">
                    {isClientView ? (
                        // Portal del Cliente: solo el nombre del BU. El client name ya está
                        // visible en el top del portal — repetirlo + pipe genera ruido visual.
                        // El indicador de canal es la barra de color a la izquierda de la fila.
                        <span className="bu-name-static">{this.props.businessUnitName}</span>
                    ) : (
                        <>
                            <Link className="table-link" {...this.onGuideRow(anchorAttr('dashboard_row_client'))}
                                  to={`/client/${this.props.clientId}/`}>{this.props.clientName}</Link>
                            |
                            <Link className="table-link" {...this.onGuideRow(anchorAttr('dashboard_row_line'))}
                                  to={`/business-unit/${this.props.businessUnitId}/`}>{this.props.businessUnitName}</Link>
                        </>
                    )}
                </div>
                <div className="bu-tooltip">
                    <p className="tooltip-description">
                        {this._ad_account_detailed_name()}
                    </p>
                </div>
            </div>
        );

        const icons = (
            <div className="some-icons">
                {this.renderRowIcons()}
            </div>
        );

        // Portal del Cliente: el botón de expandir ("+") va a la IZQUIERDA del nombre para
        // que no se oculte al achicar la columna. La clase `portal-bu-namecell` agrupa
        // ambos a la izquierda (justify-content: flex-start).
        const uncoveredSpend = this.renderUncoveredSpend();
        return (
            <td>
                <div className={`${this.getChannelClassName()}${isClientView ? ' portal-bu-namecell' : ''}${uncoveredSpend ? ' -has-uncovered' : ''}`}>
                    {isClientView ? (<>{icons}{nameBlock}</>) : (<>{nameBlock}{icons}</>)}
                    {uncoveredSpend}
                </div>
            </td>
        );
    }

    // «No cuenta N campañas · monto»: lo que la regla de campañas de la línea deja afuera (caso Kendal). Sólo
    // la fuga de SU regla (`ruleLeakOf`): lo que no cuenta ninguna línea en una cuenta vive en «Inversión sin
    // control», adonde lleva la tarjeta gris de arriba de la tabla (UD-5). En su propio renglón, debajo del
    // nombre. Es de la agencia: el portal del cliente no lo ve.
    renderUncoveredSpend() {
        const leak = ruleLeakOf(this.props.uncoveredSpend);
        if (this.props.viewMode === 'client' || !hasUncoveredSpend(leak))
            return null;

        return <UncoveredSpendChip key="uncovered-spend"
                                   uncoveredSpend={leak}
                                   accounts={this.props.adAccountsData}
                                   businessUnitId={this.props.businessUnitId}
                                   rowClassName="usp-row"/>;
    }

    renderRowIcons() {
        const isClientView = this.props.viewMode === 'client';
        // Portal del Cliente: ocultamos snooze + labels (agency-only). Expand chevron,
        // alertas y sync icon se mantienen (read-only para el cliente).
        if (isClientView) {
            return [
                this.renderToggleDetails(),
                this.renderGeneralAlerts(),
                this.renderSyncAlert()
            ];
        }
        return [
            this.renderToggleDetails(),
            this.renderGeneralAlerts(),
            this.renderUrls(),
            this.renderLabels(),
            this.renderSnoozeButton(),
            this.renderSyncAlert()
        ]
    }

    renderToggleDetails() {
        // const tooltipMessage = !this.props.hasAdAccountsDataToShow ? "Hay una sola cuenta publicitaria configurada en el presupuesto." : null;
        const tooltipMessage = null;

        return <BusinessUnitShowAdAccountsOrCampaignsTooltip key="bu-show-ad-accounts-icon"
                                                             message={tooltipMessage}
                                                             onClick={this.props.onAdAccountsDataToggle}
                                                             // enabled={this.props.hasAdAccountsDataToShow}
                                                             enabled={true}
                                                             isShowing={this.props.AdAccountsRowsExpanded}
                                                             guideAnchor={this.onGuideRow(anchorAttr('dashboard_row_expand'))}
        />
    }

    renderSnoozeButton() {
        return (
            <SnoozeAllAlertsButton key="bu-snooze-button"
                                   businessUnitId={this.props.businessUnitId}
                                   businessUnitName={this.props.businessUnitName}
                                   clientName={this.props.clientName}
                                   isSnoozed={this.props.isSnoozed}
                                   snoozedUntil={this.props.snoozedUntil}
                                   onSnooze={this.props.onSnoozeAllAlerts}
                                   onStopSnooze={this.props.onStopSnoozeForAllAlerts}
            />
        );
    }

    renderUrls() {
        return (
            <UrlListButton key="url-list"
                           businessUnitAdAccountId={null}
                           businessUnitId={this.props.businessUnitId}
                           title={this._getBusinessUnitCompleteName()}
                           downUrlsCount={this.props.downUrlsCount}
                           hasUrls={this.props.hasUrls}
                           location={this.props.location}
            />
        );
    }

    renderLabels() {
        return (
            <AssignBusinessUnitLabelsButton key="business-unit-labels"
                                            businessUnitName={this.props.businessUnitName}
                                            businessUnitLabels={this.props.businessUnitLabels}
                                            businessUnitId={this.props.businessUnitId}
                                            onLabelsChange={this.props.onLabelsChange}
            />
        );
    }

    renderSyncAlert() {
        if (this.props.syncInformation !== null) {
            // Gira también mientras la línea se recalcula por un cambio guardado (card Fnvibexi): sin eso, el
            // Tablero mostraba los números de antes sin decir que venían otros.
            return (
                <BusinessUnitSyncAlertIcon key="bu-sync-icon"
                                           isBeingSyncedOnDemand={this.props.syncInformation.is_being_synced_on_demand
                                               || isRecalculating(this.props.syncInformation)}
                                           isOnSync={this.props.syncInformation.is_on_sync}
                                           hasSyncProblems={this.props.syncInformation.has_sync_problems}
                                           message={this.syncAlertMessage()}
                                           onClick={this.props.onBusinessUnitSync}
                />
            );
        } else {
            return null;
        }
    }

    renderGeneralAlerts() {
        // El ícono también se muestra si las cuentas traen `account_status` (agregado por cuenta:
        // sin conexión / datos no actualizados), aunque la línea no tenga alertas BU-level.
        if (this.props.generalAlerts !== null || this._hasAnyAccountStatus()) {
            const generalAlerts = this.props.generalAlerts || {};
            return (
                <BusinessUnitAdAccountGeneralAlertIcon key="no-impressions-icon"
                                                       hasNoAccessAlert={generalAlerts.has_no_access_alert}
                                                       hasImpresionAlert={generalAlerts.has_no_impression_alert}
                                                       hasCampaignsNotAssignedAlert={generalAlerts.has_campaigns_not_assigned_alert}
                                                       hasCampaignsNotAssignedAlertSnoozed={generalAlerts.has_campaigns_not_assigned_alert_snoozed}
                                                       businessUnitId={this.props.businessUnitId}
                                                       adAccountsData={this.props.adAccountsData}
                                                       doParentReReder={this.doRender}

                />
            );
        } else {
            return null;
        }
    }

    _hasAnyAccountStatus() {
        const adAccountsData = this.props.adAccountsData;
        return Array.isArray(adAccountsData) && adAccountsData.some((adAccountData) => adAccountData && adAccountData.account_status);
    }

    // helpers

    syncAlertMessage() {
        // La misma frase que la fila del aviso en Alertas (/ux 04/11). Con el tope de 10 minutos de la marca: un
        // booleano viejo no deja la celda girando para siempre (review C-03).
        if (this.props.syncInformation !== null && isRecalculating(this.props.syncInformation)) {
            return i18n.t('line_recalculation.recalculating');
        }
        if (this.props.syncInformation !== null && !this.props.syncInformation.is_being_synced_on_demand) {
            return this.syncInformationMessage();
        } else if (this.props.syncInformation !== null && this.props.syncInformation.is_being_synced_on_demand) {
            return 'Sincronizando ...'
        }
    }

    syncInformationMessage() {
        const lastSync = (this.props.syncInformation.last_sync ? this.props.syncInformation.last_sync : "Nunca");
        return `Última sincronización: ${lastSync}.`;
    }

    _getBusinessUnitCompleteName() {
        return `${this.props.clientName} | ${this.props.businessUnitName}`
    }

    _ad_account_detailed_name() {
        return `${this._getBusinessUnitCompleteName()} | ${this._adAccountInfo()}`
    }

    _adAccountInfo() {
        return this.props.adAccountsData.map((businessUnitAdAccountData) => (`${businessUnitAdAccountData['name']} [${businessUnitAdAccountData['account_id']}]`)).join(" - ")
    }
}
